import React, { useEffect, useState } from "react";
import { getActivityList } from "../../../api/casp/activity";
import { useParams } from "react-router-dom";
import { Modules } from "../../../constants/Module";
import { MemberIcon } from "../../../constants/MemberIcon";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { Action, DefaultPerPageValue } from "../../../constants/Common";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../../Components/Common/Loader";
import UserProfile from "../../../Components/casp/common/userProfile";
import { withTranslation } from "react-i18next";

const HistoryTab = ({ module, t }) => {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [readMore, setReadMore] = useState([
    {
      key: null,
      index: null,
    },
  ]);
  const params = useParams();

  useEffect(() => {
    getAllHistoryForSpecificModule();
  }, []);

  const getAllHistoryForSpecificModule = async () => {
    try {
      let queryParams;
      setIsLoading(true);
      switch (module) {
        case Modules.TICKET:
          queryParams = {
            module: module,
            moduleId: params.ticketId,
            projectId: params.projectId,
          };
      }
      const res = (
        await getActivityList({
          ...queryParams,
          page: page + 1,
          perPage: DefaultPerPageValue,
        })
      ).data.data;
      setHasMore(res.meta.currentPage !== res.meta.lastPage);
      setHistory((prevState) => {
        if (prevState !== undefined && prevState.length > 0) {
          return [...prevState, ...res.data];
        } else {
          return [...res.data];
        }
      });
      setPage((prevState) => prevState + 1);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const timeCalculate = (date) => {
    const currentDateTime = dayjs();
    const updatedDateTime = dayjs(date);
    const years = currentDateTime.diff(updatedDateTime, "years");
    const months = currentDateTime.diff(updatedDateTime, "months");
    const days = currentDateTime.diff(updatedDateTime, "days");
    const hours = currentDateTime.diff(updatedDateTime, "hours");
    const minutes = currentDateTime.diff(updatedDateTime, "minutes");
    const seconds = currentDateTime.diff(updatedDateTime, "seconds");
    if (years > 0 && years <= 2) {
      return `${years} year ago`;
    } else if (months > 0 && months <= 12) {
      return `${months} month ago`;
    } else if (days > 0 && days <= 31) {
      return `${days} days ago`;
    } else if (hours > 0 && hours <= 24) {
      return hours === 1 ? `${hours} hour ago` : `${hours} hours ago`;
    } else if (minutes > 0 && minutes < 60) {
      return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`;
    } else if (seconds > 0 && seconds < 60) {
      return seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`;
    } else if (seconds <= 0) {
      return "just now";
    }
    return dayjs(date).format("ddd, MMM D, YYYY h:mm A");
  };

  const formatText = (data) => {
    const regex = /(<([^>]+)>)/gi;
    const plainText = data.replace(regex, "");
    return plainText;
  };

  const toggleTextExpansion = (key, index) => {
    setReadMore((prev) => {
      return [...prev, { key: key, index: index }];
    });
  };

  const findExactMatch = (result, key, index) => {
    const data = result.find((el) => el.key === key && el.index === index);
    return data !== undefined ? true : false;
  };

  return (
    <div
      style={{
        height: "350px",
        overflow: history.length ? "auto" : "hidden",
      }}
    >
      <InfiniteScroll
        dataLength={history.length}
        next={getAllHistoryForSpecificModule}
        hasMore={hasMore}
        height={history?.length ? "350px" : "auto"}
        loader={isLoading && <Loader />}
      >
        <ul className="list-inline allComments historyTab height-scroll">
          {/* All list items have different designs according to the requirements */}
          {history &&
            history.map((item, index) => (
              <li className="d-flex py-3" key={index}>
                <div className="d-flex align-items-center">
                  <UserProfile user={item?.creator} avatarClassName="me-2 ml-2" profileClassName="me-2 ml-2" />
                  {item.event === Action.CREATE &&
                    item.module === Modules.TICKET && (
                      <div className="mx-2">
                        <div>
                          <span className="userName bold-text">
                            {item.payload.creator.name}
                          </span>
                          &nbsp;{t("created the")} <strong> {item.module} </strong>
                          <span className="time light-font mx-2">
                            {timeCalculate(item.createdAt)}
                          </span>
                        </div>
                      </div>
                    )}
                  {item.event === Action.CREATE &&
                    item.module === Modules.COMMENT && (
                      <div className="mx-2">
                        <div>
                          <span className="userName bold-text">
                            {item?.payload?.creator?.name}
                          </span>
                          &nbsp;{t("added the")} <strong>{t("comment")} </strong>
                          <span className="time light-font mx-2">
                             {timeCalculate(item.createdAt)}
                          </span>
                        </div>
                        {findExactMatch(readMore, "commentAdd", index) ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.payload?.comment,
                            }}
                          />
                        ) : (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formatText(item?.payload?.comment)?.slice(
                                0,
                                50
                              ),
                            }}
                          />
                        )}
                        {item?.payload?.comment?.length > 50 &&
                          !findExactMatch(readMore, "commentAdd", index) && (
                            <span
                              className="blue-pointer-text cursor-pointer"
                              onClick={() =>
                                toggleTextExpansion("commentAdd", index)
                              }
                            >
                              {"..." + t("read more")}
                            </span>
                          )}
                      </div>
                    )}
                  {item.event === Action.DELETE &&
                    item.module === Modules.COMMENT && (
                      <div className="mx-2">
                        <div>
                          <span className="userName bold-text">
                            {item?.payload?.creator?.name}
                          </span>
                          &nbsp;{t("removed the")}<strong>{t("comment")} </strong>
                          <span className="time light-font mx-2">
                             {timeCalculate(item.createdAt)}
                          </span>
                        </div>
                        {findExactMatch(readMore, "commentDelete", index) ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.payload?.comment,
                            }}
                          />
                        ) : (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formatText(item?.payload?.comment)?.slice(
                                0,
                                50
                              ),
                            }}
                          />
                        )}
                        {item?.payload?.comment?.length > 50 &&
                          !findExactMatch(readMore, "commentDelete", index) && (
                            <span
                              className="blue-pointer-text cursor-pointer"
                              onClick={() =>
                                toggleTextExpansion("commentDelete", index)
                              }
                            >
                              {"..." + t("read more")}
                            </span>
                          )}
                      </div>
                    )}
                  {item.event === Action.UPDATE &&
                    item.module === Modules.COMMENT && (
                      <div className="mx-2">
                        <div>
                          <span className="userName bold-text">
                            {item?.creator?.name}
                          </span>
                          &nbsp;{t("updated the")}<strong>{t("comment")} </strong>
                          <span className="time light-font mx-4">
                             {timeCalculate(item.createdAt)}
                          </span>
                        </div>
                        {findExactMatch(readMore, "commentUpdate", index) ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.payload?.comment.new,
                            }}
                          />
                        ) : (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formatText(
                                item?.payload?.comment.new
                              )?.slice(0, 50),
                            }}
                          />
                        )}
                        {item?.payload?.comment.new?.length > 50 &&
                          !findExactMatch(readMore, "commentUpdate", index) && (
                            <span
                              className="blue-pointer-text cursor-pointer"
                              onClick={() =>
                                toggleTextExpansion("commentUpdate", index)
                              }
                            >
                              {"..." + t("read more")}
                            </span>
                          )}
                      </div>
                    )}
                  {item.event === Action.UPDATE &&
                    item.module === Modules.TICKET && (
                      <div>
                        <div>
                          {item.payload.status &&
                            item.payload.status.old &&
                            item.payload.status.new && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                    {item.creator.name}
                                  </span>
                                  &nbsp;{t("changed the")}<strong>{t("status")}</strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                                <div className="change_status">
                                  <span className="blueText">
                                    {item.payload.status.old.name}
                                  </span>
                                  <span className="middleArrow mx-2">
                                    <ArrowRightAltOutlinedIcon />
                                  </span>
                                  <span className="blueText">
                                    {item.payload.status.new.name}
                                  </span>
                                </div>
                              </div>
                            )}
                        </div>
                        <div>
                          {item.payload.assignee &&
                            item?.payload?.assignee?.old !== null &&
                            item?.payload?.assignee?.new && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                    {item.creator.name}
                                  </span>
                                &nbsp;{t("changed the")}<strong>{t("assignee")}</strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                                <div className="d-flex align-items-center change_status">
                                  <div className="d-flex align-items-center">
                                    <span>
                                      {item.payload.assignee.old.name}
                                    </span>
                                  </div>
                                  <span className="middleArrow mx-2">
                                    <ArrowRightAltOutlinedIcon />
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <span className="mx-2">
                                      {item.payload.assignee.new.name}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          {item.payload.assignee &&
                            item?.payload?.assignee?.old === null &&
                            item?.payload?.assignee?.new && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                    {item.creator.name}
                                  </span>
                                 &nbsp;{t("added the")}<strong>{t("assignee")}</strong>
                                  <strong>
                                    {item.payload.assignee.new.name}
                                  </strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                              </div>
                            )}
                          {item.payload.assignee &&
                            item?.payload?.assignee?.old &&
                            item?.payload?.assignee?.new === null && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                    {item.creator.name}
                                  </span>
                                 &nbsp;{t('removed the')}<strong>{t('assignee')}</strong>
                                  <strong>
                                    {item.payload.assignee.old.name}
                                  </strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                              </div>
                            )}
                        </div>
                        {item.payload.name &&
                          item.payload.name.old &&
                          item.payload.name.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t('changed the')}<strong>{t("name")}</strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                              <div className="d-flex align-items-center change_status">
                                <div className="d-flex align-items-center">
                                  <span>{item.payload.name.old}</span>
                                </div>
                                <span className="middleArrow mx-2">
                                  <ArrowRightAltOutlinedIcon />
                                </span>
                                <div className="d-flex align-items-center">
                                  <span className="mx-2">
                                    {item.payload.name.new}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        {item.payload.description &&
                          item.payload.description.old &&
                          item.payload.description.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                               &nbsp;{t("updated")}<strong>{t("description")} </strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                              {findExactMatch(readMore, "description",index) ?
                               (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item.payload.description.new,
                                  }}
                                />
                              ) : (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: formatText(
                                      item.payload.description.new
                                    )?.slice(0, 50),
                                  }}
                                />
                              )}
                              {item?.payload?.description.new?.length > 50 && !findExactMatch(readMore, "description",index) && 
                              (
                                  <span
                                    className="blue-pointer-text cursor-pointer"
                                    onClick={() =>
                                      toggleTextExpansion("description", index)
                                    }
                                  >
                                    {"..." + t("read more")}
                                  </span>
                                )}
                            </div>
                          )}
                            {item.payload.description &&
                            item?.payload?.description?.old === null &&
                            item?.payload?.description?.new && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                  {item.creator.name}
                                  </span>
                                 &nbsp;{t("added the ")}<strong>{t("description ")}</strong>
                                  <strong>
                                    {item.payload.description.new.name}
                                  </strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                                {findExactMatch(readMore, "description",index) ?
                               (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item.payload.description.new,
                                  }}
                                />
                              ) : (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: formatText(
                                      item.payload.description.new
                                    )?.slice(0, 50),
                                  }}
                                />
                              )}
                              {item?.payload?.description.new?.length > 50 && !findExactMatch(readMore, "description",index) && 
                              (
                                  <span
                                    className="blue-pointer-text cursor-pointer"
                                    onClick={() =>
                                      toggleTextExpansion("description", index)
                                    }
                                  >
                                    {"..." + t("read more")}
                                  </span>
                                )}
                              </div>
                            )}
                          {item.payload.description &&
                            item?.payload?.description?.old &&
                            item?.payload?.description?.new === null && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                    {item.creator.name}
                                  </span>
                                 &nbsp;{t('removed the ')}<strong>{t('description ')}</strong>
                                  <strong>
                                    {item.payload.description.old.name}
                                  </strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                              </div>
                            )}
                        {item.payload.priority &&
                          item.payload.priority.old &&
                          item.payload.priority.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t("changed the ")}<strong>{t("priority ")}</strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                              <div className="d-flex align-items-center change_status">
                                <div className="d-flex align-items-center">
                                  <span>

                                    <strong>
                                      {item.payload.priority.old.name}
                                    </strong>
                                  </span>
                                </div>
                                <span className="middleArrow mx-2">
                                  <ArrowRightAltOutlinedIcon />
                                </span>
                                <div className="d-flex align-items-center">
                                  <span className="mx-2">
                                    <strong>
                                      {item.payload.priority.new.name}
                                    </strong>
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                           {item.payload.priority &&
                            item?.payload?.priority?.old === null &&
                            item?.payload?.priority?.new && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                  {item.creator.name}
                                  </span>
                                 &nbsp;{t("added the ")}<strong>{t("priority ")}</strong>
                                  <strong>
                                    {item.payload.priority.new.name}
                                  </strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                              </div>
                            )}
                          {item.payload.priority &&
                            item?.payload?.priority?.old &&
                            item?.payload?.priority?.new === null && (
                              <div className="mx-2">
                                <div>
                                  <span className="userName bold-text">
                                    {item.creator.name}
                                  </span>
                                 &nbsp;{t('removed the ')}<strong>{t('priority ')}</strong>
                                  <strong>
                                    {item.payload.priority.old.name}
                                  </strong>
                                  <span className="time light-font mx-2">
                                    {timeCalculate(item.createdAt)}
                                  </span>
                                </div>
                              </div>
                            )}
                        {item.payload.startDate &&
                          item?.payload?.startDate?.old &&
                          item?.payload?.startDate.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t("changed the")}<strong>{t("start date")}</strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                              <div className="d-flex align-items-center change_status">
                                <div className="d-flex align-items-center">
                                  <span>
                                    {dayjs(item.payload.startDate.old).format(
                                      "YYYY-MM-DD"
                                    )}
                                  </span>
                                </div>
                                <span className="middleArrow mx-2">
                                  <ArrowRightAltOutlinedIcon />
                                </span>
                                <div className="d-flex align-items-center">
                                  <span className="mx-2">
                                    {dayjs(item.payload.startDate.new).format(
                                      "YYYY-MM-DD"
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        {item.payload.startDate &&
                          item?.payload?.startDate.old === null &&
                          item?.payload?.startDate?.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item?.creator?.name}
                                </span>
                               &nbsp;{t("added the")}<strong> {t("start date")} </strong>
                                <strong>
                                  {dayjs(item.payload.startDate.new).format(
                                    "YYYY-MM-DD"
                                  )}
                                </strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                            </div>
                          )}
                        {item.payload.startDate &&
                          item?.payload?.startDate?.old &&
                          item?.payload?.startDate?.new === null && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t("removed the")}<strong> {t("start date")} </strong>
                                <strong>
                                  {dayjs(item.payload.startDate.old).format(
                                    "YYYY-MM-DD"
                                  )}
                                </strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                            </div>
                          )}
                        {item.payload.endDate &&
                          item?.payload?.endDate?.old &&
                          item?.payload?.endDate?.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t("changed the")}<strong> {t("end date")} </strong>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                              <div className="d-flex align-items-center change_status">
                                <div className="d-flex align-items-center">
                                  <span>
                                    {dayjs(item.payload.endDate.old).format(
                                      "YYYY-MM-DD"
                                    )}
                                  </span>
                                </div>
                                <span className="middleArrow mx-2">
                                  <ArrowRightAltOutlinedIcon />
                                </span>
                                <div className="d-flex align-items-center">
                                  <span className="mx-2">
                                    {dayjs(item.payload.endDate.new).format(
                                      "YYYY-MM-DD"
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        {item.payload.endDate &&
                          item?.payload?.endDate.old === null &&
                          item?.payload?.endDate?.new && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t("added the")}<strong> {t("end date")} </strong>
                                <span className="bold-text">
                                  {dayjs(item.payload.startDate.new).format(
                                    "YYYY-MM-DD"
                                  )}
                                </span>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                            </div>
                          )}
                        {item.payload.endDate &&
                          item?.payload?.endDate?.old &&
                          item?.payload?.endDate?.new === null && (
                            <div className="mx-2">
                              <div>
                                <span className="userName bold-text">
                                  {item.creator.name}
                                </span>
                                &nbsp;{t("removed the")}<strong> {t("end date")} </strong>
                                <span className="bold-text">
                                  {dayjs(item.payload.startDate.old).format(
                                    "YYYY-MM-DD"
                                  )}
                                </span>
                                <span className="time light-font mx-2">
                                  {timeCalculate(item.createdAt)}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    )}
                  {item.module === Modules.DOCUMENT_ASSOCIATION && (
                    <div>
                      {item.event === Action.CREATE && (
                        <div className="mx-2">
                          <div>
                            <span className="userName bold-text">
                              {item.creator.name}
                            </span>
                           &nbsp;{t("added an")}
                            <span className="bold-text"> {t("attachment")}</span>
                            <span className="time light-font mx-2">
                              {timeCalculate(item.createdAt)}
                            </span>
                          </div>
                        </div>
                      )}
                      {item.event === Action.DELETE && (
                        <div className="mx-2">
                          <div>
                            <span className="userName bold-text">
                              {item.creator.name}
                            </span>
                           &nbsp;{t("removed an")}
                            <span className="bold-text"> {t("attachment")}</span>
                            <span className="time light-font mx-2">
                              {timeCalculate(item.createdAt)}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </li>
            ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};
export default withTranslation()(HistoryTab);
